import { render, staticRenderFns } from "./consultation.vue?vue&type=template&id=31b8dbf8&scoped=true&"
import script from "./consultation.vue?vue&type=script&lang=js&"
export * from "./consultation.vue?vue&type=script&lang=js&"
import style0 from "./consultation.vue?vue&type=style&index=0&id=31b8dbf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b8dbf8",
  null
  
)

export default component.exports